import { darken, OPA_20 } from '../themeUtils.js';

export function checkbox(ctx) {
    return {
        styles: {
            main:   { border_width: 0, text_color: ctx.COLOR_SCR_TEXT, text_font: 32 },
            bullet: {
                bg_color: ctx.COLOR_BG, border_color: ctx.primary, border_width: 2,
                states: {
                    checked: { bg_color: ctx.primary, border_color: ctx.primary },
                    pressed: { bg_color: darken(ctx.COLOR_BG, OPA_20) },
                },
            },
        },
    };
}
